module.exports = __webpack_public_path__ + "static/media/different-equation-bg-1.a0d70b3b.avif";